<template>

  <ContentsProductHighPerformancePageTitle title="PES (Polyethersulfone)" />

  <section class="section-product-detail-page" >
    <div class="container">
      <div class="page-content">

        <div class="properties-applications-box">
          <ContentsTextWithImage
            title="Properties"
            image-url="/pages/products/high-performance-plastics/pes02-1.jpg"
            :contents="[
              'PES is transparent high heat resin (Tg 225c, HDT 200c). In terms of mechanical properties, it features outstanding toughness, high flexural and tensile strength. PES has excellent chemical resistance in inorganic acids, alcohols, detergent. This material is inherent FR, BPA free and easy coloring.',
            ]"
            :is-reverse="true"
            left-width="43.444%"
            right-width="56.252%"
          />
  
          <ContentsTextWithImage
            title="Applications"
            image-url="/pages/products/high-performance-plastics/pes01-1.jpg"
            credit="photo credit : https://www.3dnatives.com"
            :contents="[
              'Food contact applications, aerospace components, connectors, membranes, or other applications that need transparency, high heat and good chemical resistance, and high modulus.',
            ]"
            left-width="43.421%"
            right-width="56.275%"
          />
        </div>

      </div>
    </div>
  </section>

  <section class="section-product-detail-page section-our-partners">
    <div class="container">
      <div class="page-content">

        <ContentsOurPartners
          :partners="[
            {
              name: 'BASF',
              image: {
                width: 412,
                height: 217,
                src: '/pages/products/high-performance-plastics/psu-logo01.jpg',
              },
            },
            {
              name: 'Solvay',
              image: {
                width: 412,
                height: 217,
                src: '/pages/products/high-performance-plastics/psu-logo02.jpg',
              },
            },
          ]"
        />

      </div>
    </div>
  </section>

</template>
<script setup lang="ts">
useHead({
  title:'pes - NAGASE THAILAND Engineering Plastics',
})
</script>

<style scoped>
.properties-applications-box {
  display: flex;
  flex-direction: column;
  row-gap: 60px;
}

.section-our-partners .page-content {
  padding: 48px 0 60px;
}
</style>